// @flow
import Journey from "common/records/Journey"
import type { Action } from "./actions"
import type { State } from "booking/services/types"

const journeyReducer = (state: ?Journey = null, action: Action): ?Journey => {
  switch (action.type) {
    case "SET_JOURNEY":
      return action.payload
    default:
      return state
  }
}

export default journeyReducer

// Data selectors
// ===
export const getJourney = (state: State) => state.reservation.journey
